import React from 'react'
import './services.scss'
import 'font-awesome/css/font-awesome.min.css';
export const Services = () => {
  return (
    <section class="services" id="services">
      <div class="max-width">
        <h2 class="title">My services</h2>
        <div class="services-content">
          <div class="card">
            <div class="box">
              <i class="fas fa-laptop-code"></i>
              <div class="text">Web Development</div>
              <p>Full stack developer building high performing, user friendly, feature packed applications</p>
            </div>
          </div>
          <div class="card">
            <div class="box">
              <i class="fas fa-mobile-alt"></i>
              <div class="text">App Development</div>
              <p>App developer having experience in developing native android apps. I have an app live in play store.</p>
            </div>
          </div>
          <div class="card">
            <div class="box">
              <i class="fas fa-server"></i>
              <div class="text">Backend Architect</div>
              <p>Takes responsibility to build the structure of software application such that the application is way optimized </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
